import {
  Route,
  createHashRouter,
  createRoutesFromElements,
  RouterProvider,
} from "react-router-dom";
import { UserLayout } from "./UserLayout";
import { ErrorPage } from "../components/ErrorPage/ErrorPage";
import Home from "../pages/Home";

export const MainRouting = () => {
  const router = createHashRouter (
    createRoutesFromElements (
      <>
        <Route path="/" errorElement={<ErrorPage />} element={<UserLayout />}>
          <Route index element={<Home />}></Route>
        </Route>
      </>
    )
  )
  return <RouterProvider router={router} />;
}